
import { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useDropzone } from 'react-dropzone';
import { UseFormReturn } from "react-hook-form";
import { ReadingFormValues } from "./types";

interface FileUploadFieldProps {
  form: UseFormReturn<ReadingFormValues>;
  isUploading: boolean;
}

export const FileUploadField = ({ form, isUploading }: FileUploadFieldProps) => {
  const [preview, setPreview] = useState<string | null>(null);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': []
    },
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.[0]) {
        form.setValue('file', acceptedFiles[0]);
        const objectUrl = URL.createObjectURL(acceptedFiles[0]);
        setPreview(objectUrl);
      }
    }
  });

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed rounded-lg p-4 hover:bg-gray-50 transition-colors cursor-pointer ${
        isDragActive ? 'border-primary bg-primary/10' : 'border-gray-300'
      }`}
    >
      <input {...getInputProps()} />
      <div className="text-center">
        {isUploading ? (
          <div className="flex flex-col items-center space-y-2">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            <p className="text-sm text-gray-500">Subiendo imagen...</p>
          </div>
        ) : preview ? (
          <div className="flex flex-col items-center space-y-2">
            <img
              src={preview}
              alt="Preview"
              className="max-h-32 object-contain"
            />
            <p className="text-sm text-gray-500">
              Click o arrastra para cambiar la imagen
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-2">
            <Plus className="h-8 w-8 text-gray-400" />
            <p className="text-sm text-gray-500">
              Click o arrastra una imagen aquí
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
